module.exports = __webpack_public_path__ + "img/queshengye.01c5e8d6.png";